<form class="add-pipe-model" [formGroup]="addPipeSpecForm" (ngSubmit)="addButtonClick()">
    <div class="modal-header">
        <h4 class="model-head">{{ tittle }}</h4>
        <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body output-lable new-user">
        <div class="row mb-3 mt-3">
            <div class="col-md-4">
                <mat-label class="font-style d-flex align-items-center h-100">{{ 'SETTING_PAGE.IDMS_SETTINGS.PIPE_NAME' | transloco }}</mat-label>
            </div>
            <div class="col-md-8">
                <mat-form-field class="custom-text-field" [floatLabel]="'never'">
                    <input matInput type="text" formControlName="name" />
                </mat-form-field>
            </div>
        </div>

        <div class="row mb-3 mt-3">
            <div class="col-md-4">
                <mat-label class="font-style d-flex align-items-center h-100">{{ 'SETTING_PAGE.IDMS_SETTINGS.DESCRIPTION' | transloco }}</mat-label>
            </div>
            <div class="col-md-8">
                <mat-form-field class="custom-text-field" [floatLabel]="'never'">
                    <input matInput type="text" formControlName="discription" />
                </mat-form-field>
            </div>
        </div>

        <div class="row mb-2" *ngIf="mode == 'Add'">
            <div class="col-md-4">
                <mat-label class="font-style">{{ 'SETTING_PAGE.IDMS_SETTINGS.UNIT' | transloco }}</mat-label>
            </div>
            <div class="col-md-8">
                <div class="btn-group custom-toggle-wrap" role="group">
                    <label *ngFor="let opt of stateOptions" class="btn custom-toggle" [class.active]="opt.value === addPipeSpecForm.get('pipeSizeType')?.value">
                        <input type="radio" class="btn-check" [value]="opt.value" [formControl]="addPipeSpecForm.get('pipeSizeType')" autocomplete="off" />
                        {{ opt.label }}
                    </label>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="submit" class="btn primary-ebtn" [disabled]="!(addPipeSpecForm.valid && addPipeSpecForm.dirty)">
                {{ mode == 'Add' ? ('SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco) : ('SETTING_PAGE.IDMS_SETTINGS.EDIT' | transloco) }}
            </button>
            <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
        </div>
    </div>
</form>
